import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { cn } from '@costar-ui/cosmos';
import React, { useMemo } from 'react';
import _Dialog from './aria/dialog.esm.js';

var _excluded = ["className", "maxWidth", "style"];
function Dialog(_ref) {
  var className = _ref.className,
    maxWidth = _ref.maxWidth,
    _style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useMemo(function () {
    return cn('relative flex max-h-[inherit] min-h-0 w-full overflow-auto rounded-[inherit] bg-inherit outline outline-0 print:overflow-visible', {
      'max-w-[--max-dialog-width]': !!maxWidth
    }, className);
  }, [className, maxWidth]);
  // @ts-ignore
  var style = useMemo(function () {
    return maxWidth ? _objectSpread2(_objectSpread2({}, _style), {}, {
      '--max-dialog-width': "".concat(maxWidth, "px")
    }) : _style;
  }, [_style, maxWidth]);
  return /*#__PURE__*/React.createElement(_Dialog, _extends({
    className: "csg-tw-dialog ".concat(classes),
    style: style
  }, props));
}

export { Dialog as default };
//# sourceMappingURL=dialog.esm.js.map
